import React from 'react';

function IndicatorsContainer({ children }) {
  return <div className="select-customizable__indicator">{children}</div>;
}

export default IndicatorsContainer;
